







































import Vue from 'vue'
import Avatar from '@/components/Avatar/avatar.vue'
import User from '@/models/Users/User'

export default Vue.extend({
  name: 'UserDetailRow',
  components: {Avatar},
  data () {
    return {}
  },
  props: {
    scope: Object as () => {
      pagination: {
        pageSize: number
        currentPage: number
        totalItems: number
      }
    },
    rowIndex: Number,
    toggleRowDetail: Function,
    row: Object as () => User,
  },
  methods: {
    goToUserDetails (): void {
      this.$router.push({name: 'user', params: {id: this.row.getId()}});
    },
    hasContacts (): boolean {
      return !!(this.row.getContacts() && this.row.getContacts().length);
    }
  }
})
